var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VehicleIndex',{attrs:{"fst-id":"marketplace-vehicles","page-title":_vm.$t(
      'components.marketPlaceManagement.orders.details.marketplace.steps.vehicles.headline'
    ),"isAddAnother":false,"isShowOnlyPageTitle":true,"endpoint":_vm.getEndpoint,"qso":_vm.getEndpointOptions,"filterItems":_vm.filterOptions,"tableHeaders":_vm.tableHeaders},on:{"edit":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }